import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Root = styled.div`
  > div {
    flex-grow: 1;
  }
  .wrapper-container .register {
    flex-grow: 1;
  }
  @media (max-width: 640px) {
    .wrapper-container {
      flex-wrap: wrap;
      gap: 1rem;

      .register {
        flex-grow: 1;
        .inputsWrapper {
          width: 100%;
        }
      }

      .datePickerWrapper {
        margin-left: 0;
      }
    }
  }

  .register {
    display: flex;
    align-items: center;
    background-color: var(--tonal);
    border-radius: 0.25rem;
    height: 2.5rem;
    .labelName {
      white-space: nowrap;
      padding: 0 0.75rem;
      font-size: 0.875rem;
      color: var(--text-secondary);
      border-right: 1px solid var(--outline);
      height: inherit;
      display: flex;
      align-items: center;
    }
    .inputsWrapper {
      display: flex;
      align-items: center;
    }
  }
`;

interface Props {
  workerInputSet: any;
  cdName: string;
  isViewMode: boolean;
  setWorkerInputSet: any;
}

const Passport = ({ workerInputSet, cdName, isViewMode, setWorkerInputSet }: Props) => {
  const { t } = useTranslation();
  const { wPassport } = workerInputSet;
  const [inputs, setInputs] = useState<string>(wPassport);

  useEffect(() => {
    if (inputs !== wPassport) setInputs(wPassport);
  }, [wPassport]);

  const onBlurReg = () => {
    if (inputs !== wPassport) setWorkerInputSet({ ...workerInputSet, wPassport: inputs });
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    // 영문자와 숫자만 허용하고 대문자로 변환
    const filteredValue = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    setInputs(filteredValue);
  };

  return (
    <Root className='control inputs safeedu'>
      <label htmlFor={cdName}>{t(cdName)}</label>
      <div className='flex-basic wrapper-container'>
        <div className='register'>
          <div className='inputsWrapper'>
            <input type='text' name='reg' value={inputs} maxLength={10} onChange={onChange} onBlur={onBlurReg} disabled={isViewMode} />
          </div>
        </div>
      </div>
    </Root>
  );
};

export default Passport;
